// Environment configuration for the application
export const ENV_CONFIG = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://studenthub-backend-test-env.eba-qt8t8p2j.us-east-1.elasticbeanstalk.com',
  API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
  
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
  
  // Feature Flags
  ENABLE_MOCK_DATA: process.env.REACT_APP_ENABLE_MOCK_DATA === 'true',
  ENABLE_DEBUG_LOGGING: process.env.REACT_APP_ENABLE_DEBUG_LOGGING === 'true',
  
  // Authentication
  JWT_STORAGE_KEY: process.env.REACT_APP_JWT_STORAGE_KEY || 'enpropeL_token',
  SESSION_TIMEOUT: parseInt(process.env.REACT_APP_SESSION_TIMEOUT || '3600000'), // 1 hour
  
  // UI Configuration
  DEFAULT_PAGE_SIZE: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || '10'),
  MAX_FILE_SIZE: parseInt(process.env.REACT_APP_MAX_FILE_SIZE || '5242880'), // 5MB
  
  // External Services
  GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
} as const;

// Environment helpers
export const isDevelopment = ENV_CONFIG.NODE_ENV === 'development';
export const isProduction = ENV_CONFIG.NODE_ENV === 'production';
export const isTest = ENV_CONFIG.NODE_ENV === 'test';

// Log configuration in development
if (isDevelopment && ENV_CONFIG.ENABLE_DEBUG_LOGGING) {
  console.log('🚀 Environment Configuration:', ENV_CONFIG);
}

// Validation
export const validateEnvironment = () => {
  const requiredVars = ['REACT_APP_API_BASE_URL'];
  const missing = requiredVars.filter(varName => !process.env[varName]);
  
  if (missing.length > 0) {
    console.warn('⚠️ Missing environment variables:', missing);
  }
  
  return missing.length === 0;
};

// API configuration
export const API_CONFIG = {
  baseURL: ENV_CONFIG.API_BASE_URL,
  timeout: ENV_CONFIG.API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
} as const; 